import React from "react";
import Helmet from "react-helmet";
import Link from "gatsby-link";
import HeaderImage from "../components/HeaderImage/HeaderImage";
import Pagination from "../components/Pagination";
import config from "../../data/SiteConfig";

const IndexPage = ({data, pathContext}) => {
  const {group} = pathContext;

  return (
    <div>
      <Helmet title={`Posts | ${config.siteTitle}`} />
      <HeaderImage headerImage={data.postsHeaderImage} />
      <div className="section">
        <div className="container" style={{paddingTop: "100px"}}>
          <h1 className="title is-1">
            Recent Posts
          </h1>
          <h4 className="subtitle is-4">
            {`${data.allMarkdownRemark.totalCount} total posts`}
          </h4>

          <div className="columns is-multiline">
            {
              group.map(({node}) => (
                <div className="column is-half" key={node.id}>
                  <div className="card">
                    <div className="card-content">
                      <h5 className="title is-5" style={{marginBottom: "5px"}}>
                        <Link to={`/${node.fields.slug}`}>
                          {node.frontmatter.title}
                        </Link>
                      </h5>
                      <p className="has-text-grey-light">
                        {`${node.frontmatter.date} - ${node.timeToRead} min read`}
                      </p>
                      <div>
                        {node.excerpt}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
          <Pagination pathContext={pathContext} />
        </div>
      </div>
    </div>
  );
};
export default IndexPage;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query PostQuery {
    allMarkdownRemark(filter: {frontmatter: {category: {eq: "post"}}}) {
      totalCount
    }
    postsHeaderImage: file(relativePath: { eq: "bg/weekly_recaps.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 1920) {
          ...GatsbyImageSharpSizes
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/posts.jsx